import React, { useEffect } from 'react';

const Toast = ({ message, isVisible, onClose }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-24 right-6 z-[150] w-[90%] max-w-sm animate-in slide-in-from-top-10 fade-in duration-500">
      <div className="bg-[#022c22] border border-emerald-500/30 text-white px-8 py-5 rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.4)] flex items-center gap-5 backdrop-blur-xl relative overflow-hidden">
        <div className="w-12 h-12 rounded-2xl bg-emerald-500/20 flex items-center justify-center text-emerald-400 border border-emerald-500/20 shrink-0">
          <i className="fas fa-check-circle text-2xl"></i>
        </div>
        <div>
          <h4 className="text-emerald-400 font-bold uppercase tracking-widest text-[10px] mb-1">Success</h4>
          <p className="text-sm font-medium text-emerald-50/80 leading-snug">{message}</p>
        </div>
        <button 
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          className="ml-auto text-emerald-500/40 hover:text-emerald-400 transition-colors p-2"
        >
          <i className="fas fa-times"></i>
        </button>

        {/* Progress Bar at Bottom */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-emerald-500/10 overflow-hidden">
          <div className="h-full bg-emerald-500 animate-progress origin-left"></div>
        </div>
      </div>
    </div>
  );
};

export default Toast;
